import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import domElement from 'utils/dom/domElement.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import isNotDomElement from 'utils/predicates/dom/isNotDomElement.util';

const L = logger('elementClosest');

const elementClosest = withOptions((options) => {
  try {
    const descendant = domElement(options?.descendant);
    if (isNotDomElement(descendant)) return null;

    const ancestor = fromAnyToTrimmed(options?.ancestor);

    return descendant.closest(ancestor);
  } catch (e) {
    L.warn('()', e);
    return null;
  }
});

// noinspection JSUnusedGlobalSymbols
export default elementClosest;
